import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import {   GET_WOCOMMERCE, CREATE_WOCOMMERCE, GET_SINGLE_WOCOMMERCE, UPDATE_WOCOMMERCE, DELETE_WOCOMMERCE } from "../type"

// Fetch Wocommercepricing
export const fetchWocommerceDataPricing = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_WOCOMMERCES}`;
        const response = await JsonInterceptor.get(`${apiEndpoint}`)

        dispatch({
            type: GET_WOCOMMERCE,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Create Wocommerce-Priccing
export const createWocommercePricing = (data) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.CREATE_WOCOMMERCE;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, data)
        return dispatch({
            type: CREATE_WOCOMMERCE,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: CREATE_WOCOMMERCE,
                payload: error.response.data,
            });
        }
    }
};

// Get Single Wocommerce pricing
export const fetchSingleWocommerce = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_WOCOMMERCE;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_WOCOMMERCE,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update Wocommerce pricing
export const updateWocommercePricing = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_WOCOMMERCE;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_WOCOMMERCE,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_WOCOMMERCE,
                payload: error.response.data,
            });
        }
    }
};

// Delete Wocommerce Pricing
export const deleteWocommercePricing = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_WOCOMMERCE;
        await JsonInterceptor.delete(`${apiEndpoint}/${id}`)
        dispatch({
            type: DELETE_WOCOMMERCE,
        });
    } catch (error) {
        console.log("error", error);
    }
};